
export const accessChecker = (accessName) => {
  try {
    const authData = localStorage.getItem("auth_info");
    if (!authData) {
      console.warn('No auth data found in localStorage');
      return false;
    }
    const auth = JSON.parse(authData);
    if (!auth || typeof auth !== 'object') {
      console.error('Invalid auth data structure');
      return false;
    }
    if (!Array.isArray(auth.company_user_access)) {
      console.warn('No company_user_access found or invalid format');
      return false;
    }
    const allAccess = auth.company_user_access
      .map(item => item?.access)
      .filter(Boolean); 
    const hasAccess = allAccess.includes(accessName);
    return hasAccess;
  } catch (error) {
    console.error('Error in accessChecker:', error);
  }
};

/**
 * Check if user has access to any of the given permissions
 */
export const hasAnyAccess = (accessNames = []) => {
  if (!Array.isArray(accessNames) || accessNames.length === 0) {
    return true; // No restrictions
  }
  
  return accessNames.some(accessName => accessChecker(accessName));
};

/**
 * Check if user has access to all given permissions
 */
export const hasAllAccess = (accessNames = []) => {
  if (!Array.isArray(accessNames) || accessNames.length === 0) {
    return true; // No restrictions
  }
  
  return accessNames.every(accessName => accessChecker(accessName));
};

/**
 * Get all available permissions for the current user
 */
export const getUserPermissions = () => {
  try {
    const authData = sessionStorage.getItem("auth_info");
    if (!authData) return [];
    
    const auth = JSON.parse(authData);
    
    if (!Array.isArray(auth.company_user_access)) {
      return [];
    }
    
    return auth.company_user_access
      .map(item => item?.access)
      .filter(Boolean);
  } catch (error) {
    console.error('Error getting user permissions:', error);
    return [];
  }
};

/**
 * Check if user has specific tab access
 */
export const hasTabAccess = (tabName) => {
  try {
    const authData = sessionStorage.getItem("auth_info");
    if (!authData) return false;
    
    const auth = JSON.parse(authData);
    
    if (!Array.isArray(auth.tab)) {
      return false;
    }
    
    return auth.tab.some(tab => tab.tab === tabName);
  } catch (error) {
    console.error('Error checking tab access:', error);
    return false;
  }
};

const ADMIN_ROLES = [
  "ForthERP_Basic_admin",
  "ForthERP_Standard_admin",
  "ForthERP_Pro_admin",
  "PharmaERP_Basic_admin",
  "PharmaERP_Standard_admin",
  "PharmaERP_Pro_admin",
  "PharmaBooks_Basic_admin",
  "PharmaBooks_Standard_admin",
  "PharmaBooks_Pro_admin",
  "ForthBooks_Basic_admin",
  "ForthBooks_Standard_admin",
  "ForthBooks_Pro_admin",
  "HRPayroll_Standard_admin",
  "HRPayroll_Pro_admin",
  "SuperERP_admin",
  "SuperERP_super_admin",
];

export const isAdminUser = (userRoleNames = "") => {
  if (!userRoleNames) return false;

  const roles = userRoleNames
    .split(",")
    .map((r) => r.trim());

  return roles.some((role) => ADMIN_ROLES.includes(role));
};

// authInfo.subscription is "<subscription_types.subscription_type>_<tier>"
// (e.g. "HRPayroll_Standard", "ForthERP_Pro") — HRPayroll is the only
// subscription type with no ERP/accounting modules at all, so it's the one
// case that needs ERP-only UI (like the Finance/Billing onboarding steps)
// hidden rather than just gated behind a tab check.
export const isHrmsOnlySubscription = (subscription = "") =>
  Boolean(subscription) && subscription.startsWith("HRPayroll");

